// Generated by CoffeeScript 2.4.1
(function() {
  var AttributeBuilder, AttributeNodeBuilder, DEFAULT, NodeBuilder, RelationBuilder, RelationNodeBuilder, Weaver, WeaverShaper, _, addToMap, collectNodes, mask, unmask;

  Weaver = require('./Weaver');

  _ = require('lodash');

  DEFAULT = 'clvfdszuq000008jpcezt857t-default-graph';

  NodeBuilder = class NodeBuilder {
    static instantiate(id, graph) {
      return new NodeBuilder(id, graph);
    }

    constructor(id, graph) {
      this._id = id;
      this._graph = graph;
    }

    asNode() {
      return Weaver.Node.getFromGraph(this._id, this._graph);
    }

  };

  AttributeNodeBuilder = class AttributeNodeBuilder {
    static instantiate(id, graph) {
      return new AttributeNodeBuilder(id, graph);
    }

    constructor(id, graph) {
      this._id = id;
      this._graph = graph;
    }

    asNode() {
      return Weaver.Node.getFromGraph(this._id, this._graph);
    }

  };

  RelationNodeBuilder = class RelationNodeBuilder {
    static instantiate(id, graph) {
      return new RelationNodeBuilder(id, graph);
    }

    constructor(id, graph) {
      this._id = id;
      this._graph = graph;
    }

    asNode() {
      return Weaver.Node.getFromGraph(this._id, this._graph);
    }

  };

  AttributeBuilder = class AttributeBuilder {
    static instantiate(key, value, dataType, attNode) {
      return new AttributeBuilder(key, value, dataType, attNode);
    }

    // allowed to underspecify; match as wild as you like
    constructor(key, value, dataType, attNode) {
      this._key = key;
      this._value = value;
      this._dataType = dataType;
      if (attNode !== void 0) {
        if (!(attNode instanceof AttributeNodeBuilder)) {
          throw new Error('Expected AttributeNodeBuilder');
        }
        this._attNode = attNode;
      }
    }

    key() {
      return this._key;
    }

    metaNode() {
      return this._attNode;
    }

    matchesRecord(record) {
      if (!(record instanceof Weaver.Attribute.Record)) {
        throw new Error('Expected Weaver.Attribute.Record in AttributeBuilder.matchesRecord()');
      }
      if ((this._value != null) && record.value !== this._value) {
        return false;
      }
      if ((this._dataType != null) && record.dataType !== this._dataType) {
        return false;
      }
      // todo:
      // return false if @_id? and record.attNode.id() isnt @_id
      // return false if @_graphSpecified and record.attNode.getGraph() isnt @_graph
      return true;
    }

    create(node, writes) {
      var attribute, params;
      attribute = node.attribute(this._key);
      params = {
        dataType: this._dataType
      };
      if (this._attNode != null) {
        params.id = this._attNode.asNode().id();
        params.graph = this._attNode.asNode().getGraph();
      }
      attribute.add(this._value, params);
      return Weaver.Functions.popWrites(attribute, writes);
    }

  };

  RelationBuilder = class RelationBuilder {
    static instantiate(key, target, relNode) {
      return new RelationBuilder(key, target, relNode);
    }

    // allowed to underspecify; match as wild as you like
    constructor(key, target, relNode) {
      this._key = key;
      this._target = target;
      if (relNode !== void 0) {
        if (!(relNode instanceof RelationNodeBuilder)) {
          throw new Error('Expected RelationNodeBuilder');
        }
        this._relNode = relNode;
      }
    }

    target() {
      return this._target;
    }

    key() {
      return this._key;
    }

    metaNode() {
      return this._relNode;
    }

    matchesRecord(record) {
      if (!(record instanceof Weaver.Relation.Record)) {
        throw new Error('Expected Weaver.Relation.Record in RelationBuilder.matchesRecord()');
      }
      if ((this._target != null) && !record.toNode.equals(this._target.asNode())) {
        return false;
      }
      // todo:
      // return false if @_id? and record.relNode.id() isnt @_id
      // return false if @_graphSpecified and record.relNode.getGraph() isnt @_graph
      return true;
    }

    create(node, writes) {
      var params, relation;
      relation = node.relation(this._key);
      params = {};
      if (this._relNode != null) {
        params.id = this._relNode.asNode().id();
        params.graph = this._relNode.asNode().getGraph();
      }
      relation.add(this._target.asNode(), params);
      return Weaver.Functions.popWrites(relation, writes);
    }

  };

  collectNodes = function(...maps) {
    var graph, i, id, len, list, map, node, sub;
    list = [];
    for (i = 0, len = maps.length; i < len; i++) {
      map = maps[i];
      for (graph in map) {
        sub = map[graph];
        for (id in sub) {
          node = sub[id];
          if (node instanceof NodeBuilder) {
            list.push(node.asNode());
          } else {
            list.push(node);
          }
        }
      }
    }
    return list;
  };

  mask = function(graph) {
    if (graph === void 0) {
      return DEFAULT;
    } else {
      return graph;
    }
  };

  unmask = function(key) {
    if (key === DEFAULT) {
      return void 0;
    } else {
      return key;
    }
  };

  addToMap = function(map, node, item, inArray = false) {
    var base, base1, name, name1, name2;
    if (node instanceof NodeBuilder || node instanceof AttributeNodeBuilder || node instanceof RelationNodeBuilder) {
      node = node.asNode();
    }
    if (item == null) {
      item = node;
    }
    if (map[name = mask(node.getGraph())] == null) {
      map[name] = {};
    }
    if (inArray) {
      if ((base = map[mask(node.getGraph())])[name1 = node.id()] == null) {
        base[name1] = [];
      }
      return map[mask(node.getGraph())][node.id()].push(item);
    } else {
      return (base1 = map[mask(node.getGraph())])[name2 = node.id()] != null ? base1[name2] : base1[name2] = item;
    }
  };

  WeaverShaper = (function() {
    class WeaverShaper {
      static shape() {
        return new WeaverShaper();
      }

      constructor() {
        this.createNodeMap = {}; // graph -> id -> NodeBuilder
        this.metaNodeMap = {}; // graph -> id -> [ AttributeNodeBuilder or RelationNodeBuilder ]
        this.metaProperties = []; // this is an array because we have to retain the order (because it can be meta on meta)
        this.createPropertyMap = {}; // source graph -> source id -> [ AttributeBuilder or RelationBuilder ]
        this.deleteNodeMap = {}; // graph -> id -> NodeBuilder
        this.baselineMap = {}; // graph -> id -> Node
      }

      has(nodes, ...properties) {
        var i, j, len, len1, node, property;
        if (!_.isArray(nodes)) {
          nodes = [nodes];
        }
        for (i = 0, len = nodes.length; i < len; i++) {
          node = nodes[i];
          if (node instanceof NodeBuilder) {
            this._hasNode(node);
          } else if (node instanceof AttributeNodeBuilder || node instanceof RelationNodeBuilder) {
            this._hasMetaNode(node);
          } else {
            throw new Error('Expected NodeBuilder, AttributeNodeBuilder or RelationNodeBuilder');
          }
          for (j = 0, len1 = properties.length; j < len1; j++) {
            property = properties[j];
            if (property instanceof AttributeBuilder) {
              this._hasAttribute(node, property);
            } else if (property instanceof RelationBuilder) {
              this._hasRelation(node, property);
            } else {
              throw new Error('Expected AttributeBuilder or RelationBuilder');
            }
          }
        }
        return this;
      }

      no(nodes, ...properties) {
        var i, j, len, len1, node, property;
        if (!_.isArray(nodes)) {
          nodes = [nodes];
        }
        for (i = 0, len = nodes.length; i < len; i++) {
          node = nodes[i];
          if (properties.length === 0) {
            this.noNode(node);
          }
          for (j = 0, len1 = properties.length; j < len1; j++) {
            property = properties[j];
            if (property instanceof AttributeBuilder) {
              this.noAttribute(node, property);
            } else if (property instanceof RelationBuilder) {
              this.noRelation(node, property);
            } else {
              throw new Error('Expected AttributeBuilder or RelationBuilder');
            }
          }
        }
        return this;
      }

      _hasNode(node) {
        if (!(node instanceof NodeBuilder)) {
          throw new Error('Expected NodeBuilder');
        }
        return addToMap(this.createNodeMap, node);
      }

      _hasMetaNode(node) {
        if (!(node instanceof AttributeNodeBuilder || node instanceof RelationNodeBuilder)) {
          throw new Error('Expected AttributeNodeBuilder or RelationNodeBuilder');
        }
        return addToMap(this.metaNodeMap, node);
      }

      _hasAttribute(node, attribute) {
        if (!(attribute instanceof AttributeBuilder)) {
          throw new Error('Expected AttributeBuilder');
        }
        if (attribute.metaNode() != null) {
          this._hasMetaNode(attribute.metaNode());
        }
        if (node instanceof NodeBuilder) {
          return addToMap(this.createPropertyMap, node, attribute, true);
        } else if (node instanceof AttributeNodeBuilder || node instanceof RelationNodeBuilder) {
          return this.metaProperties.push({
            node,
            property: attribute
          });
        } else {
          throw new Error('Expected NodeBuilder, AttributeNodeBuilder or RelationNodeBuilder');
        }
      }

      _hasRelation(node, relation) {
        if (!(relation instanceof RelationBuilder)) {
          throw new Error('Expected RelationBuilder');
        }
        if (relation.metaNode() != null) {
          this._hasMetaNode(relation.metaNode());
        }
        if (node instanceof NodeBuilder) {
          this._hasNode(relation.target()); // todo: allow to point to meta node
          return addToMap(this.createPropertyMap, node, relation, true);
        } else if (node instanceof AttributeNodeBuilder || node instanceof RelationNodeBuilder) {
          return this.metaProperties.push({
            node,
            property: relation
          });
        } else {
          throw new Error('Expected NodeBuilder, AttributeNodeBuilder or RelationNodeBuilder');
        }
      }

      noNode(node) {
        if (!(node instanceof NodeBuilder)) {
          throw new Error('Expected NodeBuilder');
        }
        addToMap(this.deleteNodeMap, node);
        return this;
      }

      noAttribute(node, attribute) {
        if (!(node instanceof NodeBuilder)) {
          throw new Error('Expected NodeBuilder');
        }
        if (!(attribute instanceof AttributeBuilder)) {
          throw new Error('Expected AttributeBuilder');
        }
        return this;
      }

      noRelation(node, relation) {
        if (!(node instanceof NodeBuilder)) {
          throw new Error('Expected NodeBuilder');
        }
        if (!(relation instanceof RelationBuilder)) {
          throw new Error('Expected RelationBuilder');
        }
        return this;
      }

      async plan() {
        var graph, i, id, j, k, len, len1, len2, list, node, properties, property, ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, res, sub;
        this.writes = [];
        ref = this.deleteNodeMap;
        // Cancel creates that also get deleted
        for (graph in ref) {
          sub = ref[graph];
          for (id in sub) {
            node = sub[id];
            if ((ref1 = this.createNodeMap[mask(graph)]) != null) {
              delete ref1[id];
            }
          }
        }
        // Load baseline
        list = collectNodes(this.createNodeMap, this.deleteNodeMap, this.metaNodeMap);
        res = (await new Weaver.Query().restrict(list).withAttributes().withRelations().limitRelations(99999).unlimited());
        for (i = 0, len = res.length; i < len; i++) {
          node = res[i];
          addToMap(this.baselineMap, node);
        }
        ref2 = this.createNodeMap;
        for (graph in ref2) {
          sub = ref2[graph];
          for (id in sub) {
            node = sub[id];
            if (((ref3 = this.baselineMap[graph]) != null ? ref3[id] : void 0) == null) {
              this.createNodeMap[graph][id] = new Weaver.Node(id, unmask(graph));
              Weaver.Functions.popWrites(this.createNodeMap[graph][id], this.writes);
            }
          }
        }
        ref4 = this.createPropertyMap;
        for (graph in ref4) {
          sub = ref4[graph];
          for (id in sub) {
            properties = sub[id];
            for (j = 0, len1 = properties.length; j < len1; j++) {
              property = properties[j];
              this._createProperty(graph, id, property);
            }
          }
        }
        ref5 = this.deleteNodeMap;
        for (graph in ref5) {
          sub = ref5[graph];
          for (id in sub) {
            node = sub[id];
            if (((ref6 = this.baselineMap[graph]) != null ? ref6[id] : void 0) != null) {
              Weaver.Functions.batchRemove([node], this.writes);
            }
          }
        }
        ref7 = this.metaProperties;
        for (k = 0, len2 = ref7.length; k < len2; k++) {
          ({node, property} = ref7[k]);
          this._createProperty(mask(node.asNode().getGraph()), node.asNode().id(), property);
        }
        return this;
      }

      _createProperty(graph, id, property) {
        var existingFound, i, j, len, len1, node, record, records, ref, ref1, ref2, ref3, ref4, ref5;
        if (property instanceof AttributeBuilder) {
          node = ((ref = this.baselineMap[graph]) != null ? ref[id] : void 0) || ((ref1 = this.createNodeMap[graph]) != null ? ref1[id] : void 0) || ((ref2 = this.metaNodeMap[graph]) != null ? ref2[id] : void 0);
          records = node.attribute(property.key()).allRecords();
          if (records.length === 0) {
            return property.create(node, this.writes);
          } else {
            existingFound = false;
            for (i = 0, len = records.length; i < len; i++) {
              record = records[i];
              existingFound |= property.matchesRecord(record);
            }
            if (!existingFound) {
              return property.create(node, this.writes);
            }
          }
        } else if (property instanceof RelationBuilder) {
          node = ((ref3 = this.baselineMap[graph]) != null ? ref3[id] : void 0) || ((ref4 = this.createNodeMap[graph]) != null ? ref4[id] : void 0) || ((ref5 = this.metaNodeMap[graph]) != null ? ref5[id] : void 0);
          records = node.relation(property.key()).allRecords();
          if (records.length === 0) {
            return property.create(node, this.writes);
          } else {
            existingFound = false;
            for (j = 0, len1 = records.length; j < len1; j++) {
              record = records[j];
              existingFound |= property.matchesRecord(record);
            }
            if (!existingFound) {
              return property.create(node, this.writes);
            }
          }
        } else {
          throw new Error('Expected AttributeBuilder or RelationBuilder in createPropertyMap');
        }
      }

      async preview() {
        if (this.writes == null) {
          await this.plan();
        }
        return this.writes;
      }

      async do() {
        if (this.writes == null) {
          await this.plan();
        }
        return (await Weaver.Functions.executeWrites(this.writes));
      }

    };

    WeaverShaper.node = NodeBuilder.instantiate;

    WeaverShaper.attributeNode = AttributeNodeBuilder.instantiate;

    WeaverShaper.relationNode = RelationNodeBuilder.instantiate;

    WeaverShaper.attribute = AttributeBuilder.instantiate;

    WeaverShaper.relation = RelationBuilder.instantiate;

    return WeaverShaper;

  }).call(this);

  // Export
  module.exports = WeaverShaper;

}).call(this);
